
<div class="container-fluid">
    <div class="main">
        <div class="row flex-nowrap">

            <div class="col-2, no-gutters">
                <img [ngStyle]="imageStyles" src="assets/images/NewGame.png" (click)="newGame()" />
            </div>

            <div class="col-2, no-gutters">
                <div *ngIf="handModel.isGameComplete; else elseBlockC">
                    <img [ngStyle]="imageStyles" src="assets/images/ReplayGame.png" (click)="handModel.replayGame()" />
                </div>
                <ng-template #elseBlockC>
                    <div *ngIf="handModel.isUndoAllowed; else elseBlockD">
                        <img [ngStyle]="imageStyles" src="assets/images/Undo.png"  (click)="handModel.undoSquare()" />
                    </div>
                    <ng-template #elseBlockD>
                        <img [ngStyle]="imageStyles" src="assets/images/Blank.png"  (click)="handModel.undoSquare()" />
                    </ng-template>
                </ng-template>
            </div>

            <div class="col-2, no-gutters">
                <div *ngIf="handModel.isGameStarted && !handModel.isGameComplete; else elseBlockCard">
                    <img [ngStyle]="imageStyles" src="assets/images/{{handModel.currentCard.imageName}}.png" />
                </div>
                <ng-template #elseBlockCard>
                    <div>
                        <img [ngStyle]="imageStyles" src="assets/images/Blank.png" />
                    </div>
                </ng-template>
            </div>

            <div class="col-4">
                <h4>{{handModel.scoreText}}</h4>
            </div>

            <div class="col-2, no-gutters">
                <img [ngStyle]="imageStyles" src="assets/images/GameOptions.png" (click)="openOptionDialog()" />
            </div>

        </div>

        <div class="row flex-nowrap" *ngFor="let handRow of handModel.handRows">
            <div class="col-2, no-gutters" *ngFor="let square of handRow.squares">
                <div *ngIf="square.isAvailable; else elseBlock1">
                    <img [ngStyle]="imageStyles" src="assets/images/Available1.png" (click)="handModel.setNextSquare(square.handRow, square.handCol)" />
                </div>
                <ng-template #elseBlock1>
                    <div *ngIf="square.isScore; else elseBlock2">
                        <img [ngStyle]="imageStyles" src="assets/images/{{square.imageName}}.png" />
                    </div>
                    <ng-template #elseBlock2>
                        <div>
                        <img [ngStyle]="imageStyles" src="assets/images/{{square.cardModel.imageName}}.png" />
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </div>
    </div>
</div>
by MickBraz
